/*******************
 SPANISH PASS CONFIGS
*******************/
// TODO remove duplicate rules in any condition (e.g. two of the same rule within an OR, only the second will count)
export const PASS_CONFIGS_ES_MX = {
  configId: "PASS_CONFIGS_ES_MX",
  disabledInterventionTypes: [
    "cognate",
    "tense",
    "sayit",
    "spellout",
  ],
  pass1: {
    errorCountThreshold: 2, // Num sentence level errors must be greater than threshold to trigger a pass1 intervention
    recencyWindow: 2, // Do not do a sentence level intervention if one has occurred in the last N sentences.
    occuranceMax: 2, // Do not do more than occuranceMax pass1 interventions in the last occuranceWindow sentences.
    occuranceWindow: 8,
    selectionRulesByIntervention: {
      read: {},
      repeatsentence: {},
      repeatsentenceErrorsEmphasized: {},
      toofast: {
        isRushingCheck: (rushingDetected) => (rushingDetected),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 2),
        phraseIndexCheck: (phraseIndex) => (phraseIndex > 2),
      },
    }
  },
  pass2: {
    selectionRulesByIntervention: {
      comprehension: {
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        isSightWord: (isSightWord) => (isSightWord == 0),
        isEarlyReader: (isEarlyReader) => !isEarlyReader,
        or: {
          and1: {
            studentAreaCheck: (area) => ((area >= 5.5) && (area < 8)),
            wordAreaCheck: (wordArea) => (wordArea > 5.0),
          },
          and2: {
            studentAreaCheck: (area) => (area >= 8.0),
          },
        },
      },
      prediction: {
        studentAreaCheck: (area) => (area > 7.0),
        isEndOfPhrase: (isEndOfPhrase) => (isEndOfPhrase),
        interventionOccurrenceCheck: (occurrenceCount) => occurrenceCount < 1,
      },
      tense: {
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 3),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        isEndOfPhrase: (isEndOfPhrase) => (isEndOfPhrase),
        isStemError: (isStemError) => (isStemError),
      },
    },
  },
  pass3: {
    selectionRulesByIntervention: {
      letterFlies: {
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        isSightWord: (isSightWord) => (isSightWord == 0),
        studentAreaCheck: (area) => (area < 6.0),
        syllableCheck: (numSyllable) => (numSyllable == 1),
        graphemeCheck: (numGrapheme) => ((numGrapheme > 1) && (numGrapheme <= 4)),

      },
      riddle: {
        or1: {
          and1: {
            studentAreaCheck: (area) => (area <= 6.5),
            wordDifficultyCheck: ['LIKELY_MASTERED', true],
          },
          and2: {
            studentAreaCheck: (area) => (area > 6.5),
          }
        }
      },
      clap: {
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 3),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        syllableCheck: (numSyllable) => (numSyllable > 1),
        or1: {
          and1: {
            studentAreaCheck: (area) => (area <= 6.5),
            wordDifficultyCheck: ['LIKELY_MASTERED', false],
            wordAreaCheck: (wordArea) => (wordArea > 5.5),
          },
          and2: {
            studentAreaCheck: (area) => ((area > 6.5) && (area <= 8)),
            wordDifficultyCheck: ['PROBABLY_MASTERED', false],
            syllableCheck: (numSyllable) => (numSyllable > 1),
            wordAreaCheck: (wordArea) => (wordArea > 6.5),
          },
          and3: {
            studentAreaCheck: (area) => (area > 8),
            wordDifficultyCheck: ['PROBABLY_MASTERED', false],
            syllableCheck: (numSyllable) => (numSyllable > 2),
            wordAreaCheck: (wordArea) => (wordArea > 7.5),
          },
        },
      },
      simpledefinition: {
        studentAreaCheck: (area) => (area >= 6.5),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 4),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        or: {
          and1: {
            studentAreaCheck: (area) => ((area > 6.5) && (area < 8)),
            wordAreaCheck: (wordArea) => (wordArea > 5.1),
            phonemeCheck: (numPhonemes) => (numPhonemes > 4),
          },
          and2: {
            studentAreaCheck: (area) => (area >= 8),
            wordAreaCheck: (wordArea) => (wordArea > 5.1),
            phonemeCheck: (numPhonemes) => (numPhonemes > 4),
          },
        },
      },
      funfact: {
        studentAreaCheck: (area) => (area >= 6.5),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 4),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        isEndOfPhrase: (isEndOfPhrase) => (isEndOfPhrase),
      },
      lipsync: {
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 5),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        or: {
          and1: {
            studentAreaCheck: (area) => (area <= 6.5),
            wordDifficultyCheck: ['LIKELY_MASTERED', false],
          },
          and2: {
            studentAreaCheck: (area) => (area >= 6.5),
          },
        },
      },
      phonemeLipsync: {
        studentAreaCheck: (area) => (area < 6.5),
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 3),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        isEndOfPhrase: (isEndOfPhrase) => (!isEndOfPhrase),
        phonemeCheck: (numPhonemes) => ((numPhonemes >= 3) && (numPhonemes <= 4)),
      },
      wordDisplay: {
        studentAreaCheck: (area) => (area <= 6.1),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 2),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        phonemeCheck: (numPhonemes) => (numPhonemes < 5),
      },
      sayASound: {
        studentAreaCheck: (area) => (area <= 6.0),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 3),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        isEndOfPhrase: (isEndOfPhrase) => (isEndOfPhrase),
        phonemeCheck: (numPhonemes) => (numPhonemes < 4),
        syllableCheck: (numSyllable) => (numSyllable < 2),
        isCloseError: (isCloseError) => (!isCloseError),
      },
      rhyming1: {
        studentAreaCheck: (area) => (area >= 5.5),
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 3),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        syllableCheck: (numSyllable) => (numSyllable < 2),
        wordDifficultyCheck: ['LIKELY_MASTERED', true],
        isCloseError: (isCloseError) => (!isCloseError),
        or: {
          and1: {
            studentAreaCheck: (area) => ((area >= 5.5) && (area < 8)),
            phonemeCheck: (numPhonemes) => ((numPhonemes >= 3) && (numPhonemes <= 4)),
            isSkipError: (isSkipError) => (!isSkipError),
            wordAreaCheck: (wordArea) => (wordArea < 6.0),
          },
          and2: {
            studentAreaCheck: (area) => (area >= 8.0),
            phonemeCheck: (numPhonemes) => ((numPhonemes >= 3) && (numPhonemes <= 4)),
            isSkipError: (isSkipError) => (!isSkipError),
            wordAreaCheck: (wordArea) => (wordArea < 6.3),
          },
        },
      },
      elkoninBox1: {
        studentAreaCheck: (area) => (area < 6.5),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 3),
        isSightWord: (isSightWord) => (isSightWord == 0),
        isCloseError: (isCloseError) => (!isCloseError),
        phonemeCheck: (numPhonemes) => ((numPhonemes >= 3) && (numPhonemes <= 5)),
        wordAreaCheck: (wordArea) => (wordArea < 6.8),
        or: {
          and1: {
            studentAreaCheck: (area) => (area < 5.5),
            graphemeCheck: (numGrapheme) => ((numGrapheme >= 3) && (numGrapheme <= 4)),
          },
          and2: {
            studentAreaCheck: (area) => ((area >= 5.5) && (area < 6.5)),
            graphemeCheck: (numGrapheme) => ((numGrapheme >= 3) && (numGrapheme <= 4)),
          },
        },
      },
      wordScramble1: {
        studentAreaCheck: (area) => ((area >= 6.3) && (area <= 7.2)),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 3),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        isEndOfPhrase: (isEndOfPhrase) => (isEndOfPhrase),
        wordAreaCheck: (wordArea) => (wordArea < 6.0),//changed 319
        phonemeCheck: (numPhonemes) => ((numPhonemes > 3) && (numPhonemes < 5)),
      },
      wordInvestigator1: {
        studentAreaCheck: (area) => ((area >= 5.6) && (area <= 6.0)),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 3),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        phonemeCheck: (numPhonemes) => ((numPhonemes > 2) && (numPhonemes < 5)),
        isEndOfPhrase: (isEndOfPhrase) => (!isEndOfPhrase),
        isSightWord: (isSightWord) => (isSightWord == 0),
        isCloseError: (isCloseError) => (!isCloseError),
        isSkipError: (isSkipError) => (!isSkipError),
      },
      wordInvestigator2: {
        studentAreaCheck: (area) => ((area >= 6.5) && (area <= 7.5)),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 3),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        phonemeCheck: (numPhonemes) => ((numPhonemes > 3) && (numPhonemes < 6)),
        isEndOfPhrase: (isEndOfPhrase) => (!isEndOfPhrase),
        isSightWord: (isSightWord) => (isSightWord == 0),
        isSkipError: (isSkipError) => (!isSkipError),
      },
      elkoninBox4: {
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 2),
        studentAreaCheck: (area) => ((area >= 6.5) && (area < 8.0)),
        isSightWord: (isSightWord) => (isSightWord == 0),
        isSkipError: (isSkipError) => (!isSkipError),
        graphemeCheck: (numGrapheme) => ((numGrapheme > 3) && (numGrapheme <= 6)),
      },
      vocabularyWithPictures: {
        or: {
          and1: {
            studentAreaCheck: (area) => ((area >= 6.5) && (area < 7.0)),
            wordAreaCheck: (wordArea) => (wordArea > 3),
          },
          and2: {
            studentAreaCheck: (area) => ((area >= 7.0) && (area < 8.0)),
            wordAreaCheck: (wordArea) => (wordArea > 3),
          },
          and3: {
            studentAreaCheck: (area) => ((area >= 8) && (area < 90)),
            wordAreaCheck: (wordArea) => (wordArea > 3),
          },
        },
      },
    },
  },
  pass4: {
    selectionRulesByIntervention: {
      repeatsentenceErrorsEmphasized: {
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        isEndOfPhrase: (isEndOfPhrase) => (isEndOfPhrase),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 3),
      },
      changeOnePart1: {
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 2),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        or: {
          and1: {
            studentAreaCheck: (area) => ((area >= 5.4) && (area < 6.5)),
            wordAreaCheck: (wordArea) => (wordArea < 8.2),
            lettersVsPhonemesCheck: (numLetters, numPhonemes) => (numLetters == numPhonemes),
          },
          and2: {
            studentAreaCheck: (area) => ((area >= 6.5) && (area < 7.8)),
            wordAreaCheck: (wordArea) => (wordArea < 7.2),
            lettersVsPhonemesCheck: (numLetters, numPhonemes) => (numLetters >= numPhonemes),
          },
        },
        phonemeCheck: (numPhonemes) => ((numPhonemes >= 3) && (numPhonemes <= 5)),
        lettersVsPhonemesCheck: (numLetters, numPhonemes) => (numLetters >= numPhonemes),
      },
      giveAndTake1: {
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 2),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        studentAreaCheck: (area) => ((area >= 7) && (area < 8.8)),
        phonemeCheck: (numPhonemes) => ((numPhonemes >= 3) && (numPhonemes <= 5)),
        lettersVsPhonemesCheck: (numLetters, numPhonemes) => (numLetters > numPhonemes),
      },
      sayOneSound1: {
        studentAreaCheck: (area) => ((area >= 5.0) && (area <= 6.3)),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 3),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
      },
      wordScramble1: {
        studentAreaCheck: (area) => ((area >= 6.3) && (area <= 6.9)),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 3),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        wordDifficultyCheck: ['LIKELY_MASTERED', true],
        phonemeCheck: (numPhonemes) => ((numPhonemes > 2) && (numPhonemes < 5)),
      },
      soundSeeker: {
        studentAreaCheck: (area) => (area <= 5.8),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 3),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        phonemeCheck: (numPhonemes) => (numPhonemes < 4),
        isSightWord: (isSightWord) => (isSightWord == 0),
      },
      wordInvestigator1: {
        studentAreaCheck: (area) => ((area >= 5.2) && (area <= 6.0)),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 3),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        phonemeCheck: (numPhonemes) => ((numPhonemes > 2) && (numPhonemes < 5)),
        isSightWord: (isSightWord) => (isSightWord == 0),
        isCloseError: (isCloseError) => (!isCloseError),
        isSkipError: (isSkipError) => (!isSkipError),
      },
      wordInvestigator2: {
        studentAreaCheck: (area) => ((area >= 6.0) && (area <= 7.5)),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 3),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        phonemeCheck: (numPhonemes) => ((numPhonemes > 3) && (numPhonemes < 6)),
        isSightWord: (isSightWord) => (isSightWord == 0),
        isSkipError: (isSkipError) => (!isSkipError),
      },
      rhymingQuiz1: {
        studentAreaCheck: (area) => (area <= 8.8),
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 2),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        phonemeCheck: (numPhonemes) => ((numPhonemes > 3) && (numPhonemes < 6)),
        isSkipError: (isSkipError) => (!isSkipError),
        or: {
          and1: {
            studentAreaCheck: (area) => (area < 7.5),
            wordAreaCheck: (wordArea) => (wordArea < 6.0),
          },
          and2: {
            studentAreaCheck: (area) => (area >= 7.5),
            wordAreaCheck: (wordArea) => (wordArea < 7.2),
          },
        },
      },
      simpledefinition: {
        studentAreaCheck: (area) => (area <= 6.5),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 4),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        or: {
          and1: {
            studentAreaCheck: (area) => (area < 5.5),
            wordAreaCheck: (wordArea) => (wordArea > 5.0),
          },
          and3: {
            studentAreaCheck: (area) => (area < 6.5),
            wordAreaCheck: (wordArea) => (wordArea > 5.5),
            phonemeCheck: (numPhonemes) => (numPhonemes > 3),
          },
        },
      },
      funfact: {
        studentAreaCheck: (area) => (area <= 6.5),
        isEndOfPhrase: (isEndOfPhrase) => (isEndOfPhrase),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 4),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        wordDifficultyCheck: ['LIKELY_MASTERED', true],
      },
      videoLipsync: {
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 4),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
      },
      phonemeLipsync: {
        studentAreaCheck: (area) => (area >= 6.5),
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 4),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        or: {
          and1: {
            wordDifficultyCheck: ['MAYBE_MASTERED',false],
            studentAreaCheck: (area) => (area >= 8),
            isCloseError: (isCloseError) => (isCloseError),
            isSkipError: (isSkipError) => (!isSkipError),
            frametimeCheck: ['LONG', true],
          },
          and2: {
            studentAreaCheck: (area) => ((area > 6.5) && (area <= 8)),
            wordDifficultyCheck: ['MAYBE_MASTERED',false],
            frametimeCheck: ['LONG', true],

          },
        },
      },
      vocabularyWithPictures: {
        studentAreaCheck: (area) => (area <= 6.5),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 4),
        or: {
          and1: {
            studentAreaCheck: (area) => (area < 5.5),
            wordAreaCheck: (wordArea) => (wordArea > 3.0),
          },
          and2: {
            studentAreaCheck: (area) => ((area >= 5.5) && (area < 6.5)),
            wordAreaCheck: (wordArea) => (wordArea > 3.5),
          },
        },
      },
    }
  },
  //Pass 5 is the "no intervention" pass. See intervention_selector/passes/pass_5 directory for details
  //pass5:{},
  pass6: {
    giveWordProbabilityForStudentArea: {
      low: 0.82,
      mid: 0.88,
      high: 0.88,
    },
    selectionRulesByIntervention: {
      simpledefinition: {
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        or1: {
          and1: {
            studentAreaCheck: (area) => (area <= 6.5),
            wordAreaCheck: (wordArea) => (wordArea > 5.0)
          },
          and2: {
            studentAreaCheck: (area) => ((area > 6.5) && (area < 8.0)),
            wordAreaCheck: (wordArea) => (wordArea > 6.0)
          },
          and3: {
            studentAreaCheck: (area) => (area >= 8.0),
            wordAreaCheck: (wordArea) => (wordArea > 6.5)
          },
        },
      },
      clap: {
        isEndOfPhrase: (isEndOfPhrase) => (isEndOfPhrase),
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        wordReadingDifficultyCheck: ['PROBABLY_MASTERED', false],
        or1: {
          and1: {
            syllableCheck: (numSyllable) => (numSyllable > 1),
            studentAreaCheck: (area) => (area < 8),
          },
          and2: {
            syllableCheck: (numSyllable) => (numSyllable > 2),
            studentAreaCheck: (area) => (area >= 8),

          }
        }
      },
      funfact: {
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        wordDifficultyCheck: ['LIKELY_MASTERED', true],
      },
      lipsync: {
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        wordDifficultyCheck: ['LIKELY_MASTERED', false],
      },
      phonemeLipsync: {
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        or1: {
          and1: {
            studentAreaCheck: (area) => (area <= 6.5),
            phonemeCheck: (numPhonemes) => (numPhonemes > 2),
            phonemeCheck: (numPhonemes) => (numPhonemes < 5),
            wordDifficultyCheck: ['PROBABLY_MASTERED', false],
          },
          and2: {
            studentAreaCheck: (area) => ((area > 6.5) && (area <= 7.5)),
            phonemeCheck: (numPhonemes) => (numPhonemes >= 4),
            phonemeCheck: (numPhonemes) => (numPhonemes < 6),
            wordDifficultyCheck: ['PROBABLY_MASTERED', false],
          },
        },
      },
      spelloutBefore: {
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        relativeRecentlyOccurredCheck: (relativeRecentOccurrence) => (relativeRecentOccurrence == 0),
        phonemeCheck: (numPhonemes) => (numPhonemes <= 6),
        isCloseError: (isCloseError) => (!isCloseError),
        isSkipError: (isSkipError) => (!isSkipError),
        or1: {
          and1: {
            studentAreaCheck: (area) => (area < 5.6),
            wordDifficultyCheck: ['PROBABLY_MASTERED', false],
            or2: {
              phonemeCheck: (numPhonemes) => (numPhonemes > 4),
              syllableCheck: (numSyllables) => (numSyllables > 1),
            }
          },
          and2: {
            studentAreaCheck: (area) => ((area >= 5.6) && (area < 7.5)),
            wordDifficultyCheck: ['PROBABLY_MASTERED', false],
            or3: {
              phonemeCheck: (numPhonemes) => (numPhonemes > 4),
              syllableCheck: (numSyllables) => (numSyllables > 2),
            }
          },
          and3: {
            studentAreaCheck: (area) => (area >= 7.5),
            or4: {
              phonemeCheck: (numPhonemes) => (numPhonemes >= 5),
              syllableCheck: (numSyllables) => (numSyllables > 3),
            }
          },
        },
      },
      tense: {
        isEndOfPhrase: (isEndOfPhrase) => (isEndOfPhrase),
        isStemError: (isStemError) => (isStemError),
      },
      vocabularyWithPictures: {
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 4),
      },
    },
  },
  pass7: {
    readyScoreQualificationThreshold: 0,
    selectionRulesByIntervention: {
      simpledefinition: {},
      clap: {
        syllableCheck: (numSyllable) => (numSyllable > 1),
      },
      funfact: {
        wordDifficultyCheck: ['LIKELY_MASTERED', true],
      },
      soundout3: {
        recentlyOccurredCheck: (recentOccurrence) => (recentOccurrence == 0),
        interventionOccurrenceCheck: (occurrenceCount) => (occurrenceCount < 3),
      },
      lipsync: {},
      vocabularyWithPictures: {},
      spelloutBefore: {
        wordDifficultyCheck: ['LIKELY_MASTERED', false],
        syllableCheck: (numSyllable) => (numSyllable < 2),
      },
    }
  },
  scorePass1: {
    READY_wordLevelDelta: .2, // interventions accumulate .2 when not selected/played at the word level
    READY_phraseLevelDelta: .4, // interventions accumulate .4 when not selected/played at the the phrase level
    READY_interventionUsedDelta: -2, // interventions deccumulate -2 when played by the app
  },
  scorePass2: {
    FRUSTRATION_interventionDelta: 1.1,
    FRUSTRATION_wordInterventionDelta: .5,
    FRUSTRATION_noInterventionDelta: -1,
  }
} // end of configs
